import script from "./ModalMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMsg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__